import React from 'react';
import {View, ViewStyle} from 'react-native';
import {clamp, noop} from 'lodash';

import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {styles, variants} from './ProgressBar.style';

interface ProgressBarProps {
  getTheme: (key: string) => any;
  style: {
    base: ViewStyle;
    fill: ViewStyle;
  };
  progress: number;
  variant: 'thin' | null;
  testID: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  getTheme = noop,
  style = {base: {}, fill: {}},
  progress = 0,
  variant = null,
  testID = '',
}) => {
  const styleArray: ViewStyle[] = [styles.base, variants.defaultBase];
  if (variant === 'thin') {
    styleArray.push(variants.thinBase);
  }
  styleArray.push(style.base);

  const fillStyleArray: ViewStyle[] = [
    styles.fill,
    getTheme('competency.backgroundColor'),
    {width: `${clamp(progress, 0, 100)}%`},
    variants.defaultFill,
  ];

  if (variant === 'thin') {
    fillStyleArray.push(variants.thinFill);
  }
  fillStyleArray.push(style.fill);

  return (
    <View {...testProperties(testID)} style={styleArray} testID={testID}>
      <View style={fillStyleArray} />
    </View>
  );
};

export default withHOC(withTheme, withCompetency)(ProgressBar);
